import MantSkuVehiculo from './MantSkuVehiculo';
import SkuVehiculoDetalle from './SkuVehiculoDetalle';
//<88181> 
export default {
  route: {
    index: {
      path: '/mantenimiento-sku-vehiculo',
      component: MantSkuVehiculo
    },
    editar: {
      path: '/mantenimiento-sku-vehiculo/detalle',
      component: SkuVehiculoDetalle
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/index.js